import { useRouter } from 'next/router'
import Link from 'next/link'
import Image from 'next/image'
import { MinimalTopbar, MinimalFooter } from '@big-red-group/storefront-common-ui'
import { LOGO_PATH, MOBILE_LOGO_PATH, BRG_LOGO_PATH } from '@/constant/ui'
import { useElementClick } from '@/hooks/HTMLElementClickHook'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { useContext } from 'react'
import FooterPicker from '@/components/FooterPicker'

export const MinimalTopbarWrapper = () => {
  const router = useRouter()
  const { lang } = router.query
  const safeLang = typeof lang === 'string' ? lang : ''
  const pageUrl = router.asPath

  const defaultProperties = useContext(DefaultPropertiesContext)

  const siteTitle = defaultProperties?.agentConfiguration?.siteTitle
  const isVirgin = defaultProperties?.agentConfiguration?.handlerKey === 'virgin'
  const whiteLabelLogo = defaultProperties?.agentConfiguration?.style?.logo?.image

  const linkClick = useElementClick('Link')

  const TrackedLinkComponent = ({ href, children, ...rest }: { href: string; children: React.ReactNode }) => {
    // add analytics to homepage link
    const isHomeLink = href === `/${safeLang}`
    return (
      <Link
        href={href}
        data-testid={isHomeLink ? 'HomeIconLink' : undefined}
        onClick={(event) => {
          if (isHomeLink) {
            linkClick({ location: 'TopBar | Home Icon', text: 'Home', event })
          }
        }}
        {...rest}
      >
        {children}
      </Link>
    )
  }

  return (
    <MinimalTopbar
      logo={whiteLabelLogo ?? LOGO_PATH}
      mobileLogo={whiteLabelLogo ?? MOBILE_LOGO_PATH}
      logoAlt={siteTitle}
      isVirgin={isVirgin}
      lang={safeLang}
      pageUrl={pageUrl}
      onNavigate={(url) => router.push(url)}
      LinkComponent={TrackedLinkComponent}
      ImageComponent={({ src, alt, width, height, className }) => (
        <Image src={src} alt={alt} width={width} height={height} className={className} />
      )}
    />
  )
}

export const MinimalFooterWrapper = () => {
  const linkClick = useElementClick('Link')

  const defaultProperties = useContext(DefaultPropertiesContext)
  const handlerKey = defaultProperties?.agentConfiguration?.handlerKey
  const siteTitle = handlerKey === 'virgin' ? 'Experience OZ' : defaultProperties?.agentConfiguration?.siteTitle
  const isBookingEngine = defaultProperties?.agentConfiguration?.isBookingEngine

  if (!isBookingEngine) {
    return (
      <MinimalFooter
        BRGLogo={BRG_LOGO_PATH}
        siteTitle={siteTitle}
        useElementClick={() => linkClick}
        LinkComponent={({ href, children, ...rest }) => (
          <Link href={href} {...rest}>
            {children}
          </Link>
        )}
        ImageComponent={(props) => <Image {...props} />}
      />
    )
  }
  return <FooterPicker />
}
